import React from 'react';
import { Hyperlink } from '../../atoms/Hyperlink';
import { SVG, Icons } from '../../atoms/SVG';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export enum SearchBreadcrumbModifier {
  NO_MARGIN_BOTTOM = 'no-margin-bottom',
}

export type SearchBreadcrumb = {
  breadcrumbs: { name: string; url?: string }[];
  clickable?: boolean;
  modifier?: Modifier<SearchBreadcrumbModifier>;
};

export function SearchBreadcrumb({ breadcrumbs, modifier, clickable = true }: SearchBreadcrumb) {
  const { t } = useSonTranslation('SearchBreadcrumb');

  /**
   * In some cases when SolR-Indexer didn't run properly, it returns urls without their name.
   * This causes links without link name, which is an accessibility violation.
   * So we only return links that have indexed names here.
   */
  const listItem = (item: { name: string; url?: string }) => {
    return (
      <li className={bem('search-breadcrumb__item', modifier)} key={item.name}>
        <span className="search-breadcrumb__icon">
          <SVG svgSpriteId={Icons.BREADCRUMB_SLASH} />
        </span>
        {clickable && item?.url ? (
          <Hyperlink to={item.url} className="search-breadcrumb__link">
            {item.name}
          </Hyperlink>
        ) : (
          <span className="search-breadcrumb__span">{item.name}</span>
        )}
      </li>
    );
  };

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <ul className="search-breadcrumb" aria-label={t('path')}>
      {breadcrumbs.map(item => listItem(item))}
    </ul>
  );
}
